"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import GradientButton from "@/components/ui/GradientButton";
import { FaChevronRight } from "react-icons/fa";
import Image from "next/image";
import { motion } from "framer-motion";
import { crmSolutionTypes } from "./crm.data";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
export default function CrmTypes() {
  const $ = _c(48);
  const desktopAnimations = useDesktopAnimations();
  let t0;
  if ($[0] !== desktopAnimations) {
    t0 = desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false;
    $[0] = desktopAnimations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== desktopAnimations) {
    t1 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== desktopAnimations) {
    t2 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      once: true,
      amount: 0.3
    };
    t4 = {
      duration: 0.7,
      ease
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t0 || $[9] !== t1 || $[10] !== t2) {
    t5 = <motion.h2 initial={t0} whileInView={t1} animate={t2} viewport={t3} transition={t4} className="font-poppins max-w-[520px] text-[28px] font-bold leading-[1.4] text-[#0b1354] md:text-[40px] dark:text-white">Types of Home Service App Solutions</motion.h2>;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== desktopAnimations) {
    t6 = desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false;
    $[12] = desktopAnimations;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== desktopAnimations) {
    t7 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[14] = desktopAnimations;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== desktopAnimations) {
    t8 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[16] = desktopAnimations;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t10;
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      once: true,
      amount: 0.3
    };
    t10 = {
      duration: 0.7,
      delay: 0.08,
      ease
    };
    $[18] = t10;
    $[19] = t9;
  } else {
    t10 = $[18];
    t9 = $[19];
  }
  let t11;
  if ($[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
    t11 = <motion.p initial={t6} whileInView={t7} animate={t8} viewport={t9} transition={t10} className="mb-0 max-w-[460px] font-sans text-[16px] font-normal leading-[30px] text-[#6b7280] md:pt-1.5 md:text-[17px] dark:text-gray-300">We create custom on-demand home service apps for startups and businesses, tailored to your needs.</motion.p>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t5) {
    t12 = <div className="mb-12 flex flex-col gap-5 md:mb-[70px] md:flex-row md:items-start md:justify-between md:gap-10">{t5}{t11}</div>;
    $[24] = t11;
    $[25] = t5;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== desktopAnimations) {
    t13 = crmSolutionTypes.map((item, index) => <motion.article key={item.title} initial={desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false} whileInView={desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined} animate={desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.7,
      delay: index * 0.1,
      ease
    }} className="group relative flex h-full flex-col overflow-hidden rounded-[16px] bg-white dark:bg-gray-800/90 dark:border dark:border-gray-700/80 shadow-[0_6px_28px_rgba(20,60,100,0.07)] dark:shadow-none transition-transform duration-[1200ms] ease-[cubic-bezier(0.17,0.85,0.438,0.99)] hover:-translate-y-[7.5px]"><Image src={item.image} alt={item.title} width={1200} height={880} className="aspect-[136/100] w-full object-cover" /><div className="px-6 pt-[30px] pb-8"><h3 className="font-poppins mb-3 text-[22px] font-bold leading-[30px] text-[#0b1354] dark:text-white">{item.title}</h3><p className="mb-0 font-sans text-[16px] font-normal leading-[30px] text-[#6b7280] dark:text-gray-300">{item.description}</p></div><span className="absolute inset-x-0 bottom-0 h-1 origin-left scale-x-0 bg-[linear-gradient(135deg,#9100ff_0%,#3663ff_54%,#00e2ff_100%)] transition-transform duration-[1200ms] ease-[cubic-bezier(0.17,0.85,0.438,0.99)] group-hover:scale-x-100" /></motion.article>);
    $[27] = desktopAnimations;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t13) {
    t14 = <div className="grid grid-cols-1 gap-8 md:grid-cols-3">{t13}</div>;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== desktopAnimations) {
    t15 = desktopAnimations ? {
      opacity: 0,
      y: 24
    } : false;
    $[31] = desktopAnimations;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== desktopAnimations) {
    t16 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[33] = desktopAnimations;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== desktopAnimations) {
    t17 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[35] = desktopAnimations;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  let t19;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      once: true,
      amount: 0.3
    };
    t19 = {
      duration: 0.7,
      ease
    };
    $[37] = t18;
    $[38] = t19;
  } else {
    t18 = $[37];
    t19 = $[38];
  }
  let t20;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <GradientButton href="/contact" variant="peach-pink">Get a Free Consultation <FaChevronRight className="ml-1 text-[12px]" /></GradientButton>;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== t15 || $[41] !== t16 || $[42] !== t17) {
    t21 = <motion.div initial={t15} whileInView={t16} animate={t17} viewport={t18} transition={t19} className="mt-9 text-center md:mt-10">{t20}</motion.div>;
    $[40] = t15;
    $[41] = t16;
    $[42] = t17;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t12 || $[45] !== t14 || $[46] !== t21) {
    t22 = <section className="bg-gradient-to-br from-[#f1fbf8] via-[#f8f8fd] to-[#efebfa] py-[70px] transition-colors duration-300 md:py-[90px] dark:from-gray-900 dark:via-gray-950 dark:to-gray-950"><div className="mx-auto w-full max-w-[1290px] px-[15px]">{t12}{t14}{t21}</div></section>;
    $[44] = t12;
    $[45] = t14;
    $[46] = t21;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  return t22;
}